import React from 'react';
import { connect } from 'react-redux';

class ImageDisplay extends React.PureComponent {
  render() {
    const { id, values } = this.props;

    if (values.images && values.images[id]) {
      return (
        <div className="mb-2">
          <img
            src={values.images[id]}
            alt={id}
            style={{
              width: '200px',
            }}
          />
        </div>
      );
    }

    return null;
  }
}

const mapStateToProps = (store) => ({
  values: store.sites.values,
});

export default connect(mapStateToProps)(ImageDisplay);
